import { specialCharacters, DATE_FORMAT_SHORT_YEAR } from "constants/globals";
import { INCREASING_GREEN, DECREASING_RED, BLACK } from "constants/colors";
import { Instrument } from "apis/models/commons/instrument";
import { getInstrumentData } from "apis/instrumentApi";
import { arrayValidation, isEmpty, sortRows } from "../../../utils/functions";
import {
  comparer,
  getDateByString,
  formatInstrumentForLS,
  getJulianDateStringFromDate,
  formatInstrumentWithPositionFieldsForLS,
} from "utils/helpers";
import { Column } from "models/common";
import { formats } from "./constants";
import { Card } from "./types";

export const sliceInstrumentDescription = (instrumentList: Instrument[]) =>
  instrumentList
    .map((instrument) => {
      return encodeURIComponent(instrument.uniqueKey);
    })
    .join();

export const getInstrumentWithAdditionalFields = (tableData: Array<any>, instrumentsData: Instrument[]) => {
  const instrumentsWithAdditionalFields = [];
  tableData.forEach(function getInstrument(instrument) {
    const filteredData = instrumentsData.find((singleInstrument) => singleInstrument.symbol === instrument.descripcion);

    let descripcionInstrumento;
    if (filteredData && filteredData.name && filteredData.name !== "0") {
      descripcionInstrumento = filteredData.name;
    }

    const newInstrument = {
      ...instrument,
      symbol: filteredData ? filteredData.symbol : null,
      displaySymbol: filteredData ? filteredData.displaySymbol : null,
      descripcionInstrumento,
      instrumentId: filteredData ? filteredData.instrumentId : null,
      marketTypeId: filteredData ? filteredData.marketTypeId : null,
      valueTypeId: filteredData ? filteredData.valueTypeId : null,
      exchangeId: filteredData ? filteredData.exchangeId : null,
    };
    instrumentsWithAdditionalFields.push(newInstrument);
  });
  return instrumentsWithAdditionalFields;
};

export const precessTableRows = (instruments: Instrument[], rows: Array<any>) => {
  let tableRows = rows || [];
  let instrumentWithoutData = [];

  const instrumentsToLoad = instruments.map((instrument) => ({
    descripcion: instrument.symbol,
  }));

  if (instruments.length !== tableRows.length) {
    instrumentWithoutData = instrumentsToLoad.filter(comparer(tableRows));
  }

  tableRows = tableRows.concat(instrumentWithoutData);
  return sortRows(getInstrumentWithAdditionalFields(tableRows, instruments), "symbol");
};

export const fetchTableData = async (instruments: Instrument[], fields: string) => {
  let newArrStart = 0;
  let newArrEnd = 199;
  let newAPI;
  let instrumentsLength = instruments.length;
  let resp = [];
  let tableRows = [];
  let finalResp = [];
  if (instruments && instruments.length > 0) {
    if (instruments.length <= 200) {
      const instrumentsStringIds = sliceInstrumentDescription(instruments);

      try {
        const resp = await getInstrumentData(instrumentsStringIds, fields);
        if (resp && resp.data) {
          tableRows = resp.data;
        }
        return precessTableRows(instruments, tableRows);
      } catch (error) {
        throw error;
      }

      return [];
    } else {
      for (let i = instrumentsLength; instrumentsLength >= 0; i--) {
        newAPI = instruments.slice(newArrStart, newArrEnd);

        const instrumentsStringIds = sliceInstrumentDescription(newAPI);
        try {
          finalResp.push(await getInstrumentData(instrumentsStringIds, fields));
        } catch (error) {
          console.log(error, "error");
        }

        newArrStart = newArrStart + 199 + 1;
        newArrEnd = newArrEnd + 199 + 1;
        instrumentsLength = instrumentsLength - 200;
      }

      const finalArray = [];

      for (let i = 0; i < finalResp.length; i++) {
        finalArray.push(...finalResp[i].data);
      }

      let tableRows = [];
      try {
        if (resp) {
          tableRows = finalArray;
        }
        return precessTableRows(instruments, finalArray);
      } catch (error) {
        console.log(error);
      }
    }
  }
  return [];
};

const separarCoumnas = (cell: string) => {
  if (cell) {
    const REGEX_ONLY_NUMBER = /(\d+)/g;
    const REGEX_ONLY_LETTERS = /([a-zA-z])/g;
    const row = cell.match(REGEX_ONLY_NUMBER).join("");
    const column = cell.match(REGEX_ONLY_LETTERS).join("");
    return { row, column };
  }
  return null;
};

const getCellActive = (address: string) => {
  let cellActive = null;

  if (address) {
    cellActive = address.split("!")[1];
  }

  if (cellActive) {
    return separarCoumnas(cellActive);
  }

  return null;
};

const processRange = (row, initialColumn, headerLength) => {
  let valueFinalColumn;
  let valueInitialColumn = "";

  if (initialColumn && initialColumn.length > 1) {
    valueFinalColumn = initialColumn.substr(initialColumn.length - 1, initialColumn.length);
    valueInitialColumn = initialColumn.substr(0, initialColumn.length - 1).toLowerCase();
  } else {
    valueFinalColumn = initialColumn;
  }

  let startCharCode = valueFinalColumn.toLowerCase().charCodeAt(0) - 1;
  const endCharCode = "z".charCodeAt(0);
  let count = 0;
  let finalcolumn;
  let isHeaderMax = false;
  while (!isHeaderMax) {
    if (startCharCode === endCharCode) {
      startCharCode = "a".charCodeAt(0);
      startCharCode--;
      if (valueInitialColumn) {
        let tempValueInitialColumn = valueInitialColumn.charCodeAt(0);
        tempValueInitialColumn++;
        valueInitialColumn = String.fromCharCode(tempValueInitialColumn);
      } else {
        valueInitialColumn = "a";
      }
    }

    startCharCode++;
    count++;

    if (count === headerLength) {
      finalcolumn = String.fromCharCode(startCharCode).toUpperCase();
      isHeaderMax = true;
    }
  }

  return {
    initialRow: row,
    finalRow: row,
    initialColumn: initialColumn.toUpperCase(),
    finalColumn: `${valueInitialColumn}${finalcolumn}`.toUpperCase(),
  };
};

export const calculateRange = (cellActive: string, headerLength: number) => {
  const data = getCellActive(cellActive);

  if (data) {
    const { row, column } = data;
    return processRange(row, column, headerLength);
  }
  return null;
};

export const getNextColumn = (column: string): string => {
  let valueInitialColumn = "";
  let valueFinalColumn;

  if (column && column.length > 1) {
    valueInitialColumn = column.substr(0, column.length - 1);
    valueFinalColumn = column.substr(column.length - 1, column.length).toLowerCase();
  } else {
    valueFinalColumn = column;
  }

  let nextColumn = valueFinalColumn.toLowerCase().charCodeAt(0);
  const endCharCode = "z".charCodeAt(0);

  if (nextColumn != endCharCode) {
    nextColumn++;
    nextColumn = String.fromCharCode(nextColumn).toUpperCase();
    return `${valueInitialColumn}${nextColumn}`;
  }

  if (valueInitialColumn) {
    let next: number | string = valueInitialColumn.toLowerCase().charCodeAt(0);
    next++;
    next = String.fromCharCode(next).toUpperCase();
    return `${next}A`;
  }
  return "AA";
};

export const convertValue = (value: any, header: Column, isRealTime: boolean) => {
  let newValue = "-";

  if (isEmpty(value)) {
    return newValue;
  }

  const tempValue = String(value);
  const { format } = header;

  let replaced;

  let porcentaje = header.apiField === "porcentaje" ? " %" : "";

  if (!porcentaje) {
    porcentaje = header.isPercentage ? "%" : "";
  }
  switch (format) {
    case formats.STRING:
      if (tempValue.startsWith("+") || tempValue.startsWith("-")) {
        newValue = "'" + tempValue;
      } else {
        newValue = tempValue;
      }
      break;
    case formats.FLOAT:
      replaced = tempValue.replace(/,/g, "").replace("%", "");
      newValue = replaced === "0" ? "0" : `${parseFloat(replaced)}`;
      break;
    case formats.DATE:
      const date = isRealTime && !isNaN(Number(tempValue)) ? getJulianDateStringFromDate(Number(tempValue)) : tempValue;
      newValue = getDateByString(date, DATE_FORMAT_SHORT_YEAR);
      break;
    case formats.TIME:
      newValue = tempValue.slice(1, 2) === specialCharacters.COLON ? `0${value}` : tempValue;
      newValue = newValue.length === 5 ? `${newValue}:00` : newValue;
      break;
    case formats.INT:
      replaced = tempValue.replace(/,/g, "");
      newValue = `${Number(replaced)}`;
      break;
    case formats.FIGURE:
      replaced = tempValue.replace(/,/g, "");
      newValue = `${parseFloat(replaced)}`;
      break;
    default:
      break;
  }

  return String(`${newValue}${porcentaje}`);
};

export const getFormatInstrumentForLS = (instruments: Instrument[]) => {
  if (!arrayValidation(instruments)) {
    return [];
  }

  const formatInstruments = [];

  instruments.forEach((instrument) => {
    formatInstruments.push(
      formatInstrumentForLS(
        instrument.symbol,
        "",
        instrument.marketTypeId,
        instrument.valueTypeId,
        instrument.exchangeId
      )
    );
  });

  return formatInstruments;
};

export const getFormatInstrumentWithPositionFieldsForLS = (instruments: Instrument[]): Array<string> => {
  if (!arrayValidation(instruments)) {
    return [];
  }

  const formatInstruments = [];

  instruments.forEach((instrument) => {
    formatInstruments.push(
      formatInstrumentWithPositionFieldsForLS(
        instrument.symbol,
        instrument.marketTypeId,
        instrument.valueTypeId,
        instrument.exchangeId
      )
    );
  });

  return formatInstruments;
};

const colorFormatting = (value: number | null) => {
  if (isEmpty(value)) {
    return BLACK;
  }
  if (Number(value) > 0) {
    return INCREASING_GREEN;
  }
  if (Number(value) <= 0) {
    return DECREASING_RED;
  }
  return BLACK;
};

export const getColor = (header: Column, currentValue: string, newValue: string, isUpdateCell: boolean) => {
  const color = BLACK;

  if (header.apiField === "porcentaje") {
    return colorFormatting(isUpdateCell ? Number(newValue) : Number(currentValue));
  }

  if (!isUpdateCell) {
    return color;
  }

  const convertNewValue = newValue ? convertValue(newValue, header, false) : "";

  if (String(currentValue) === convertNewValue) {
    return color;
  }

  if (isEmpty(currentValue) || currentValue === "-") {
    return INCREASING_GREEN;
  }

  const isNumber = header.format === formats.FLOAT || header.format === formats.INT || header.format === formats.FIGURE;
  if (isNumber) {
    return Number(convertNewValue) < Number(currentValue) ? DECREASING_RED : INCREASING_GREEN;
  }

  return color;
};

const getNumberByLetter = (letter: string): number => {
  let number = 0;
  for (let char = 0; char < letter.length; char++) {
    number += letter.charCodeAt(char);
  }
  return number;
};

const cellIsInRange = (card: Card, dataCellActive: { currectRow: number; currectColumn: string }) => {
  const { currectRow, currectColumn } = dataCellActive;

  const { initialRow, initialColumn, finalColumn, rowNumber } = card;

  const EstaEnElRangoActual = currectRow >= initialRow && currectRow <= initialRow + rowNumber - 1;

  if (!EstaEnElRangoActual) {
    return false;
  }

  const temCurrectColumn = getNumberByLetter(currectColumn);

  const tempInitialColumn = getNumberByLetter(initialColumn);

  const tempFinalColumn = getNumberByLetter(finalColumn);

  return temCurrectColumn >= tempInitialColumn && temCurrectColumn <= tempFinalColumn;
};

export const getCardByAddress = (cards: Card[], address: string, worksheetId: string) => {
  let cardActive = null;

  const { row: currectRow, column: currectColumn } = getCellActive(address);

  for (let index = 0; index < cards.length; index++) {
    const card = cards[index];
    if (card.worksheetId === worksheetId) {
      if (cellIsInRange(card, { currectRow: Number(currectRow), currectColumn })) {
        cardActive = card;
        break;
      }
    }
  }

  return cardActive;
};

export const convertValueToPercentage = (value: string) => {
  if (!value) return 0;
  return Number(value) * 100;
};
